 <template>
  <div class="form-group">
    <draggable
      class="row wrap fill-height align-center sortable-list"
      style="padding: 1em;"
      v-model="tmpValue"
    >
      <CCol
        v-for="row, idx in tmpValue"
        :key="'images-box-col-' + idx"
        class="sortable form-group col-12 col-xs-6 col-sm-3"
      >
        <CRow>
          <CCol
            class="col-11"
            style="padding: 5px;"
          >
            <img
              style="cursor: pointer;"
              :src="row.url"
              width="100%"
              @click="updateImage(row)"
            />
            <CTextarea
              v-if="includeAlt"
              :label="i18nMessage.Title"
              v-model="row.alt"
              style="margin-top: 0.3em;"
            />
            <CInput
              v-if="includeLink"
              :label="i18nMessage.Link"
              v-model="row.link"
              style="margin-top: 0.3em;"
            />
          </CCol>
          <CCol
            class="col-1"
            style="padding: 0px;"
          >
            <FontAwesomeIcon 
              :icon="['fas', 'times']" 
              size="xl"
              style="cursor: pointer;"
              @click="tmpValue.splice(idx, 1)"
              v-if="showDeleteBtn"
            />
          </CCol>
        </CRow>
      </CCol>
    </draggable>
    <CCol
      class="form-group offset-9 col-3"
      v-if="showAddBtn"
    >
      <CRow>
        <CCol
          class="col-11"
        >
        </CCol>
        <CCol
          class="col-1"
          style="padding: 0px;"
        >
          <FontAwesomeIcon 
            :icon="['fas', 'plus']" 
            size="sm"
            style="cursor: pointer;"
            @click="addImage"
          />
        </CCol>
      </CRow>
    </CCol>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapState } from "vuex";

export default {
  name: "ImagesBox",
  components: {
    draggable,
  },
  props: {
    size: {
      type: Number,
    },
    minSize: {
      type: Number,
    },
    maxSize: {
      type: Number,
    },
    includeAlt: {
      type: Boolean,
      default: false,
    },
    includeLink: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array[Object],
      default: [],
    }
  },
  data() {
    const filebrowserBrowseUrl = this.$router.resolve({ 
      name: 'ImageManager',
    }).href
    return {
      tmpValue: [],
      filebrowserBrowseUrl: filebrowserBrowseUrl,
    };
  },
  computed: {
    ...mapState({
      i18nMessage: (state) => state.i18nMessage,
    }),
    showDeleteBtn() {
      return !this.size && this.value.length > (this.minSize || 1)
    },
    showAddBtn() {
      if (this.size) {
        return this.value.length < (this.size || 1)
      } else if (this.maxSize) {
        return this.value.length < this.maxSize
      } else {
        return true
      }
    }
  },
  methods: {
    addImage() {
      window.UPDATE_IMAGE_ACTION = (url) => {
        this.tmpValue.push({
          url: url,
        })
      }
      this.popupCenter(this.filebrowserBrowseUrl, '_blank', 800, 600)
    },
    updateImage(row) {
      window.UPDATE_IMAGE_ACTION = (url) => {
        row.url = url
      }
      this.popupCenter(this.filebrowserBrowseUrl, '_blank', 800, 600)
    },
    popupCenter (url, title, w, h) {
      // Fixes dual-screen position                             Most browsers      Firefox
      const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
      const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

      const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

      const systemZoom = width / window.screen.availWidth;
      const left = (width - w) / 2 / systemZoom + dualScreenLeft
      const top = (height - h) / 2 / systemZoom + dualScreenTop
      window.open(url, title, 
        `
        scrollbars=yes,
        width=${w / systemZoom}, 
        height=${h / systemZoom}, 
        top=${top}, 
        left=${left}
        `
      )
    }
  },
  mounted() {
    this.tmpValue = this.value
  },
  watch: {
    tmpValue: {
      deep: true,
      handler(newVal) {
        this.$emit('input', newVal)
      },
    },
  },
};
</script>

<style>
</style>